import { Emitter } from "pixi-particles";
import { Culture } from "../Data/Culture";
import { NoteParticleSystem } from "./NoteParticleSystem";

export class KeyNoteParticleSystem extends NoteParticleSystem {
    constructor(pCulture: Culture) {
        super(pCulture);

        this._emitter = new Emitter(this, this.getTexturesForCulture(pCulture), {
            alpha: {
                list: [
                    { value: 0, time: 0 },
                    { value: 1, time: 0.2 },
                    { value: 1, time: 0.8 },
                    { value: 0, time: 1 },
                ],
            },
            scale: {
                list: [
                    { value: 0.1, time: 0 },
                    { value: 1, time: 1 },
                ],
            },
            speed: {
                list: [
                    { value: 200, time: 0 },
                    { value: 100, time: 1 },
                ],
            },
            startRotation: { min: 0, max: 360 },
            minStartRotation: 0,
            maxStartRotation: 360,
            lifetime: { min: 0.3, max: 0.8 },
            frequency: 0.008,
            emitterLifetime: 0.2,
            maxParticles: 1000,
            pos: { x: 0, y: 0 },
            addAtBack: false,
            spawnCircle: { x: 0, y: 0, r: 10 },
            blendMode: "normal",
        });

        this.stopEmitting();
    }
}
